import { useEffect, useState } from "react";
import { AccessSystemsAPI } from "../../api/accessControl";
import { SchoolsAPI } from "../../api/lookups";

export default function AccessSystemsPage() {
  const [systems, setSystems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const [form, setForm] = useState({
    schoolId: "",
    systemName: "",
    webhookUrl: "",
  });

  const [schools, setSchools] = useState([]);

  async function load() {
    try {
      setLoading(true);
      setError("");
      const data = await AccessSystemsAPI.list();
      setSystems(Array.isArray(data) ? data : []);
      const schoolsData = await SchoolsAPI.list();
      setSchools(Array.isArray(schoolsData) ? schoolsData : []);
    } catch (err) {
      console.error(err);
      setError("Failed to load systems");
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    load();
  }, []);

  async function handleCreate(e) {
    e.preventDefault();

    try {
      await AccessSystemsAPI.create({
        schoolId: Number(form.schoolId),
        systemName: form.systemName,
        webhookUrl: form.webhookUrl,
      });

      setForm({ schoolId: "", systemName: "", webhookUrl: "" });
      load();
    } catch (err) {
      console.error(err);
      alert("Failed to create system");
    }
  }

  async function toggleSystem(id, current) {
    try {
      await AccessSystemsAPI.toggle(id, !current);
      load();
    } catch (err) {
      console.error(err);
      alert("Failed to update");
    }
  }

  async function testSystem(system) {
    try {
      await AccessSystemsAPI.test({
        schoolId: system.school_id,
        systemId: system.id,
      });

      alert("Test sent. Check jobs for result.");
    } catch (err) {
      console.error(err);
      alert("Failed to run test");
    }
  }

  return (
    <div className="p-6 space-y-6">
      <h1 className="text-2xl font-semibold">Net2 Systems</h1>

      <form
        onSubmit={handleCreate}
        className="rounded border bg-white p-4 space-y-3"
      >
        <h2 className="font-medium">Add System</h2>

        <select
          value={form.schoolId}
          onChange={(e) =>
            setForm({ ...form, schoolId: e.target.value })
          }
          className="w-full border p-2"
        >
          <option value="">Select School</option>
          {schools.map((s) => (
            <option key={s.id} value={s.id}>
              {s.name}
            </option>
          ))}
        </select>

        <input
          type="text"
          placeholder="System name"
          value={form.systemName}
          onChange={(e) =>
            setForm({ ...form, systemName: e.target.value })
          }
          className="w-full border p-2"
        />

        <input
          type="text"
          placeholder="Webhook URL"
          value={form.webhookUrl}
          onChange={(e) =>
            setForm({ ...form, webhookUrl: e.target.value })
          }
          className="w-full border p-2"
        />

        <button className="bg-blue-600 text-white px-4 py-2 rounded">
          Create
        </button>
      </form>

      {loading ? (
        <div>Loading...</div>
      ) : error ? (
        <div className="text-red-600">{error}</div>
      ) : (
        <div className="rounded border bg-white">
          <table className="w-full text-sm">
            <thead className="bg-gray-50 border-b">
              <tr>
                <th className="p-2">School</th>
                <th className="p-2">System</th>
                <th className="p-2">Webhook</th>
                <th className="p-2">Enabled</th>
                <th className="p-2"></th>
              </tr>
            </thead>
            <tbody>
              {systems.map((s) => (
                <tr key={s.id} className="border-b">
                  <td className="p-3">{s.school_name}</td>

                  <td className="p-3 font-medium">{s.system_name}</td>

                  <td className="p-3 max-w-[400px] truncate text-sm text-gray-600">
                    {s.webhook_url}
                  </td>

                  <td className="p-3">
                    <span className={s.enabled ? "text-green-600" : "text-red-600"}>
                      {s.enabled ? "Enabled" : "Disabled"}
                    </span>
                  </td>

                  <td className="p-3 space-x-3">
                    <button
                      onClick={() => toggleSystem(s.id, s.enabled)}
                      className="text-blue-600 hover:underline"
                    >
                      Toggle
                    </button>

                    <button
                      onClick={() => testSystem(s)}
                      className="text-green-600 hover:underline"
                    >
                      Test
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}